import { trimSlashes } from "@/helpers/trimSlashes";
import EnvConfig from "@/env";

export function siteRoot(uri) {
    const domain = trimSlashes(EnvConfig.SITE_ROOT_URL);
    return `${domain}${uri}`;
}